import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-transactionDown",
  "use": "icon-transactionDown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-transactionDown\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 472.576L512 1024l512-551.424H0zM708.778667 0H315.733333v472.576h393.045334V0z\" fill=\"#279E51\" p-id=\"12122\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/transactionDown.svg
// module id = IPLS
// module chunks = 154